import React from 'react'
import AdminMainNavigation from 'widgets/navigation/AdminMainNavigation'
import TabletMainNavigation from 'widgets/navigation/TabletMainNavigation'
import WhenDeviceAuthorized from 'support/conditionals/WhenDeviceAuthorized'
import WhenDeviceNotAuthorized from 'support/conditionals/WhenDeviceNotAuthorized'

export default function PrimaryNavigation () {
  return (
    <>
      <WhenDeviceNotAuthorized>
        <AdminMainNavigation />
      </WhenDeviceNotAuthorized>
      <WhenDeviceAuthorized>
        <TabletMainNavigation />
      </WhenDeviceAuthorized>
    </>
  )
}
